<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="29.911" height="29.911" viewBox="0 0 29.911 29.911">
    <g transform="translate(-12.947 -11.943)">
      <path fill="currentColor" d="M60.05 60h1.62v1.259h-1.62z" transform="translate(-43.863 -44.817)" />
      <path fill="currentColor" d="M120.05 60h9.829v1.259h-9.829z" transform="translate(-99.057 -44.817)" />
      <path fill="currentColor" d="M60.05 120h14.634v1.259H60.05z" transform="translate(-43.863 -100.553)" />
      <path
        fill="currentColor"
        d="M22.9 29.91v-3.345l3.347 3.346 3.718-3.718L22.9 19.13V0H.05v22.387l7.525 7.523zm3.346-4.956l1.24 1.239-1.239 1.239L25 26.193zM25 23.715l-1.239 1.239-8.349-8.348 1.239-1.239zm-10.825-8.348l-.473-.473-.62-1.859 1.859.62.473.473zM1.1 1.24h20.544v16.59l-5.756-5.707-5.578-1.859 1.859 5.577 9.474 9.787v3.047H8.815v-7.527H1.1zm5.962 25.679L3.042 22.9h4.02z"
        transform="translate(12.897 11.943)"
      />
      <path fill="currentColor" d="M4.159 0l4.158 4.18H0z" transform="translate(17.335 31.55) rotate(41)" />
    </g>
  </svg>
</template>
